import { IOS_IN_CALL_DISPLAY_NAME, IOS_IN_CALL_ICON_SLUG, isIosInCallService } from "./iosInCallApp";
import { IOS_SCREENSHOT_DISPLAY_NAME, IOS_SCREENSHOT_ICON_SLUG, isIosScreenshotBundleId } from "./iosScreenshotApp";
import {
  isSignalAppToken,
  rankAppTokens,
  tokenizeAppSegments,
} from "./packageSegmentStopwords";
import { SVG_ICON_CATALOG } from "./svgIconCatalog.generated";

export type LocalSvgIconInput = {
  displayName?: string | null;
  appIdentifier?: string | null;
};

export { isSignalAppToken, rankAppTokens, tokenizeAppSegments } from "./packageSegmentStopwords";

function hasLocalSvgSlug(slug: string): boolean {
  return Object.prototype.hasOwnProperty.call(SVG_ICON_CATALOG, slug);
}

function normalizeSlug(value: string): string {
  return value.trim().toLowerCase().replace(/[^a-z0-9]/g, "");
}

export function resolveLocalSvgIcon({
  displayName,
  appIdentifier,
}: LocalSvgIconInput): { slug: string; label: string } | null {
  if (isIosScreenshotBundleId(appIdentifier, displayName)) {
    return {
      slug: IOS_SCREENSHOT_ICON_SLUG,
      label: IOS_SCREENSHOT_DISPLAY_NAME,
    };
  }

  if (isIosInCallService(appIdentifier, displayName)) {
    return {
      slug: IOS_IN_CALL_ICON_SLUG,
      label: IOS_IN_CALL_DISPLAY_NAME,
    };
  }

  const displaySlug = normalizeSlug(displayName ?? "");
  if (displaySlug && hasLocalSvgSlug(displaySlug)) {
    return {
      slug: displaySlug,
      label: SVG_ICON_CATALOG[displaySlug]!,
    };
  }

  const isAppleBundle = (appIdentifier ?? "").trim().toLowerCase().startsWith("com.apple.");
  const rankedTokens = rankAppTokens([
    ...tokenizeAppSegments((appIdentifier ?? "").trim()),
    ...tokenizeAppSegments((displayName ?? "").trim()),
  ].filter((token) => isSignalAppToken(token) && !(isAppleBundle && token === "apple")));

  const slug = rankedTokens.find(hasLocalSvgSlug);
  if (!slug) return null;

  return {
    slug,
    label: SVG_ICON_CATALOG[slug]!,
  };
}
